<template>
  <history-list
    :entity-id="protocolId"
    :entity-type-id="ENTITY_TYPE.PROTOCOL" />
</template>

<script lang="ts">
import HistoryList from '@/components/history/HistoryList.vue'
import { useProtocol } from '../protocol'
import { ENTITY_TYPE } from '@/utils/constants'

export default {
  name: 'History',
  components: { HistoryList },
  setup() {
    const { protocolId } = useProtocol()

    return { ENTITY_TYPE, protocolId }
  },
}
</script>
